var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"login-sns-each apple"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.loginApple.apply(null, arguments)}}},[_c('span',{staticClass:"icon-sns icon-apple"}),_c('span',{staticClass:"a11y-hidden"},[_vm._v("Apple ID로 시작하기")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }